import domReady from "@wordpress/dom-ready";
import { createRoot } from "@wordpress/element";
import apiFetch from "@wordpress/api-fetch";
import CrudApp from "./CrudApp";
import "./style.scss"; // your scoped styles
domReady(() => {
    if (window.WPBean_PGS_Options?.nonce) {
        apiFetch.use(
            apiFetch.createNonceMiddleware(window.WPBean_PGS_Options.nonce),
        );
    }

    const el = document.getElementById("wpbean-pgs-settings-app");

    if (!el) {
        console.warn("#wpbean-pgs-settings-app not found.");
        return;
    }

    const root = createRoot(el);
    root.render(<CrudApp />);
});
